import type { OpeningHoursSpecification } from "schema-dts";

/*
 * mapOpeningHours
 */
export type OpeningHoursInput = {
  days:
    | "Mon-Fri"
    | "Mon-Thu"
    | "Mon-Sat"
    | "Mon-Sun"
    | Array<
        | "Monday"
        | "Tuesday"
        | "Wednesday"
        | "Thursday"
        | "Friday"
        | "Saturday"
        | "Sunday"
      >;
  opens?: string; // "08:00"
  closes?: string; // "17:00"
};

export function mapOpeningHours(
  items: OpeningHoursInput[],
): OpeningHoursSpecification[] {
  const expandDays = (
    days: OpeningHoursInput["days"],
  ): OpeningHoursSpecification["dayOfWeek"] => {
    if (Array.isArray(days)) {
      return days as any;
    }

    if (days === "Mon-Fri") {
      return ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
    }

    if (days === "Mon-Thu") {
      return ["Monday", "Tuesday", "Wednesday", "Thursday"];
    }

    if (days === "Mon-Sat") {
      return [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
    }

    if (days === "Mon-Sun") {
      return [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ];
    }

    return undefined;
  };

  return items.map(it => ({
    "@type": "OpeningHoursSpecification",
    dayOfWeek: expandDays(it.days),
    opens: it.opens,
    closes: it.closes,
  }));
}

/*
 * toHtml
 */
type ToHtmlOptions = {
  baseUrl?: string;
  wrapParagraphs?: boolean;
};

const DefaultToHtmlOptions: ToHtmlOptions = {
  baseUrl: process.env.NEXT_PUBLIC_DOMAIN,
  wrapParagraphs: true,
};

export function toHtml(
  input: string,
  options: ToHtmlOptions = DefaultToHtmlOptions,
) {
  let output = input.trim();

  if (options.baseUrl) {
    output = output.replace(
      /<a\s+href="(\/[^"]*)">/g,
      (_m, path) => `<a href="${options.baseUrl}${path}">`,
    );
  }

  output = output
    .split("\n")
    .map(line => line.trim())
    .join("\n");

  if (options.wrapParagraphs) {
    const parts = output
      .split(/\n{2,}/g)
      .map(part => part.trim())
      .filter(Boolean);

    output = parts.map(part => `<p>${part}</p>`).join("");
  }

  return output;
}
